module.exports = __webpack_public_path__ + "static/media/KUZMA CAR-20.d5ae0f01.png";